/**
 * A util function to filter out the Legacy Nav Bar based on feature flag enablement
 *
 * @function
 *
 * @param subMenuItem {String} key/id for a submenu item listing of a nav submenu
 * @param featureFlags {Object} an object for reading customer feature flags booleans
 */
export const filterNavSubMenuView = (subMenuItem, featureFlags) => {
  const { isEmergencyRolesUser } = featureFlags;

  if (subMenuItem.id === 'requestEmergencyAccess') {
    if (!isEmergencyRolesUser) {
      subMenuItem.submenu = subMenuItem.submenu.filter((ele) => ele.id !== 'requestEmergencyRoles');
    }
  }
};
